import { useEffect } from 'react';
import { useRouter } from 'next/router';

const BlogPage = () => {
  const router = useRouter();
  useEffect(() => {
    router.replace(`/blog/latest`);
  }, [router]);
};

export default BlogPage;
